import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from '@phosphor-icons/react';
import QuotationForm from '../components/QuotationForm';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EditPurchaseOrder() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/purchase-orders/${id}`)
      .then(res => setDoc(res.data))
      .catch(e => { console.error(e); alert('Failed to load purchase order'); })
      .finally(() => setLoading(false));
  }, [id]);

  const handleSubmit = async (data) => {
    setSaving(true);
    try {
      await axios.put(`${API}/purchase-orders/${id}`, data);
      navigate(`/purchase-order/${id}`);
    } catch (e) { console.error(e); alert('Failed to update'); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="py-20 text-center text-stone-400 text-sm">Loading...</div>;

  return (
    <div>
      <button onClick={() => navigate(`/purchase-order/${id}`)} className="inline-flex items-center gap-1.5 text-stone-500 hover:text-stone-800 text-sm font-medium mb-6 transition-colors">
        <ArrowLeft size={16} /> Back
      </button>
      <h1 className="text-3xl sm:text-4xl text-stone-900 mb-2">Edit Purchase Order</h1>
      <p className="text-sm text-stone-500 mb-8">{doc?.po_number}</p>
      <QuotationForm initialData={doc} onSubmit={handleSubmit} submitLabel="Update Purchase Order" saving={saving} docType="purchase_order" />
    </div>
  );
}
